"use strict";
import { ReactComponent as UnknownStatus } from "assets/svg/contract-interaction.svg";
import Identicon from "components/Identicon";
import CurrencyLogo from "components/Logo/CurrencyLogo";
import { DoubleCurrencyLogo } from "components/Logo/DoubleLogo";
import { memo } from "react";
import { Flex, useSporeColors } from "ui/src";
import { SplitLogo } from "uniswap/src/components/CurrencyLogo/SplitLogo";
import { TokenLogo } from "uniswap/src/components/CurrencyLogo/TokenLogo";
import { SUPPORTED_TESTNET_CHAIN_IDS } from "uniswap/src/features/chains/types";
const LOGO_DEFAULT_SIZE = 40;
export const PortfolioLogo = memo(function PortfolioLogo2(props) {
  const colors = useSporeColors();
  if (SUPPORTED_TESTNET_CHAIN_IDS.includes(props.chainId) && props.currencies?.[0]) {
    return <CurrencyLogo currency={props.currencies?.[0]} size={props.size} />;
  }
  return <Flex alignItems="center" top={0} left={0} style={props.style}><Flex position="relative">{getLogo(props, colors)}</Flex></Flex>;
});
function getLogo({
  accountAddress,
  currencies,
  images,
  symbols,
  names,
  chainId,
  customIcon,
  size = LOGO_DEFAULT_SIZE
}, colors) {
  if (accountAddress) {
    return <Identicon account={accountAddress} size={size} />;
  }
  if (currencies && currencies.length) {
    return <DoubleCurrencyLogo currencies={currencies} size={size} customIcon={customIcon} />;
  }
  if (images && images.length >= 2) {
    return <SplitLogo
      inputLogoUrl={images[0]}
      outputLogoUrl={images[1]}
      inputCurrencyInfo={null}
      outputCurrencyInfo={null}
      inputSymbol={symbols?.[0]}
      outputSymbol={symbols?.[1]}
      inputName={names?.[0]}
      outputName={names?.[1]}
      chainId={chainId}
      size={size}
    />;
  }
  if (images && images.length === 1) {
    return <TokenLogo url={images[0]} size={size} chainId={chainId} symbol={symbols?.[0]} name={names?.[0]} />;
  }
  return <UnknownStatus width={size} height={size} color={colors.neutral2.val} />;
}
